import { useEffect } from 'react';
import { isStaff } from '@/lib/landing';
import { JuniWidget } from '@/modules/juni/JuniWidget';
import { useJuniStore } from '@/modules/juni/juni-store';
import { useAuthStore } from '@/stores/auth-store';

/**
 * Juni in the dashboard, for customers: answers may describe their own account.
 *
 * Staff have no account of their own to ask about, and their dashboard is the platform's, so Juni
 * is not shown to them, except while viewing as a customer, when they see what the customer sees.
 * A conversation belongs to one sign-in and one customer: signing in as somebody else, or viewing
 * another customer, starts afresh rather than carrying one account's details into the next.
 */
export function CustomerJuni() {
  const user = useAuthStore((state) => state.user);
  const impersonation = useAuthStore((state) => state.impersonation);
  const owner = user === null ? null : `${user.id}:${impersonation?.sessionId ?? ''}`;

  useEffect(() => {
    useJuniStore.getState().claimCustomer(owner);
  }, [owner]);

  if (user === null || (isStaff(user.role) && impersonation === null)) {
    return null;
  }

  return <JuniWidget audience="customer" />;
}
